import {InjectionToken} from '@angular/core';

export const SUPPORT_CONFIG = new InjectionToken('mydocma-support-config');

export interface SupportConfig {
  apiUrl?: string;
  defaultTicket?: {
    custom_fields?: {
      module: string;
      nutzungsart?: string;
    }
  };
}
